/**
 * eslint-disable no-lone-blocks
 *
 * @format
 */

/** @format */
import { useGetWebinarsQuery } from "store/services/adminAPI";
import React, { useEffect } from "react";
import { FadeLoader } from "react-spinners";
import { Col, Card } from "react-bootstrap";
import EmptyNotice from "component/ErrorNotice";
import course1 from "images/courses/cohort2.jpg";
import { Link, useNavigate } from "react-router-dom";
import { ReactComponent as PlayIcon } from "images/svg/paly.svg";
import { Path } from "utils/constant.data";
import { ReactComponent as SearchIcon } from "images/svg/search.svg";
import { useState } from "react";
import { ReactComponent as FilterIcon } from "images/svg/filter.svg";
import WebinarFilterModal from "./WebinarFilter";
import { CustomSelect } from "../../Leaderboard/styles/customStyles";
import WebinarPagination from "./WebinarPagination";
import { PAGE_SIZE } from "utils/constant.data";
import { useSelector } from "react-redux";
import "react-datepicker/dist/react-datepicker.css";
import { capitalize } from "utils/strings";

const Webinars = () => {
  const profileState = useSelector((state) => state.profile);
  const _profile = profileState?.profileInfo?.data?.profile || null;
  const fellowType = _profile?.current_program ?? "3mtt";

  const [filter, setFilter] = useState(
    `page=1&page_size=${PAGE_SIZE[1]}&current_program=${fellowType}`
  );
  const [skip, setSkip] = useState(false);
  const [showModal, setModal] = useState(false);

  const { data, isLoading, isFetching } = useGetWebinarsQuery(filter, {
    skip,
  });
  const [searchTerm, setSearchTerm] = useState("");
  const [category, setCategory] = useState("");
  const [filteredWebinars, setFilteredWebinars] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (data) {
      setFilteredWebinars([...data?.data?.results]);
    }
  }, [data]);



  useEffect(() => {
    if (filter && filter.length > 0) {
      setSkip(false);
    }
  }, [filter]);

  const webinars = data?.data?.results ?? [];
  const metadata = data?.data?.metadata ?? null;

  return (
    <Col xl="12">
      <WebinarFilterModal isVisible={false} />

      {isLoading || isFetching ? (
        <div className="d-flex justify-content-center align-items-center height-15 bg-white ">
          <FadeLoader color="#36d7b7" />
        </div>
      ) : (
        <>
          <div className="d-flex justify-content-center mb-4 webinars-filter cont">
            <div className="search-wrapper webinar-search ">
              <div className="search-icon">
                <SearchIcon />
              </div>
              <input
                type="text"
                className="search-input"
                placeholder="Search by title or description"
                value={searchTerm}
                onChange={(e) => {
                  setSearchTerm(e.target.value);
                  const regex = new RegExp(e.target.value, "i");

                  const filtered = webinars?.filter(
                    (webinar) =>
                      regex.test(webinar.title) ||
                      regex.test(webinar.description)
                  );

                  setFilteredWebinars([...filtered]);
                }}
              />
            </div>

            <div className="filter-section">
              <div className="filter-group">
                <CustomSelect
                  value={category}
                  onChange={(e) => {
                    setCategory(e);

                    if (e.value === "down") {
                      const oldest = [...webinars]?.sort((a, b) => {
                        const dateA = new Date(a.created_at);
                        const dateB = new Date(b.created_at);
                        return dateB - dateA;
                      });
                      setFilteredWebinars([...oldest]);
                    }

                    if (e.value === "up") {
                      const newest = [...webinars]?.sort((a, b) => {
                        const dateA = new Date(a.created_at);
                        const dateB = new Date(b.created_at);
                        return dateA - dateB;
                      });
                      setFilteredWebinars([...newest]);
                    }
                  }}
                  options={[
                    { label: "Newest to Oldest", value: "down" },
                    { label: "Oldest to Newest", value: "up" },
                  ]}
                  placeholder="Sort Webinars"
                />
              </div>
            </div>

            <div className="filter-controls">
              <button
                className={`filter-btn`}
                onClick={() => setModal(true)}
                // ref={filterIconRef}
              >
                <FilterIcon />
              </button>
            </div>
          </div>

          <Card className="transparent">
            {filteredWebinars?.length > 0 ? (
              <>
                <div className="row">
                  {filteredWebinars?.map((webinar) => {
                    return (
                      <div
                        className="col-xl-4 col-md-6 webinar-card cont"
                        key={webinar?.id}
                      >
                        <div className="card all-crs-wid">
                          <div className="card-body">
                            <div className="courses-bx">
                              <div
                                className="courses-cards"
                                onClick={() => {
                                  navigate(
                                    `${Path.COMMUNITY_WEBINARS}/${webinar?.id}`
                                  );
                                }}
                              >
                                <div className="dlab-media">
                                  <img
                                    src={
                                      webinar?.thumbnail
                                        ? webinar?.thumbnail
                                        : course1
                                    }
                                    alt="Webinar Thumbnail"
                                  />
                                  <span className="indicator">
                                    {webinar?.episodes?.length} Video
                                    {webinar?.episodes?.length > 1 ? "s" : ""}
                                  </span>
                                </div>

                                <div className="course-card front"></div>
                                <div className="course-card back"></div>
                              </div>

                              <div className="dlab-info">
                                <div className="dlab-title d-flex justify-content-between">
                                  <div>
                                    <h4>
                                      <Link to={webinar?.link}>
                                        {capitalize(webinar?.title)}
                                      </Link>
                                    </h4>
                                  </div>
                                </div>
                                <div className="d-flex justify-content-start content align-items-center">
                                  <Link
                                    to={`${Path.COMMUNITY_WEBINARS}/${webinar?.id}`}
                                    className="btn btn-sm"
                                  >
                                    <PlayIcon />
                                    <span className="ms-1"> View All</span>
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>

                <WebinarPagination metadata={metadata} setFilter={setFilter} />
              </>
            ) : (
              <Card.Body>
                <EmptyNotice type="webinar" text="No webinar at the moment" />
              </Card.Body>
            )}
          </Card>

          <WebinarFilterModal fellowType={fellowType} isVisible={showModal} setVisible={setModal} setFilter={setFilter}  metadata={metadata} />
        </>
      )}
    </Col>
  );
};

export default Webinars;
